export type WorkerInitializer = () => void;

export default function createWebWorker(worker: WorkerInitializer): Worker {
  const code = worker.toString();
  const blob = new Blob([`(${code})()`], { type: "text/javascript" });
  return new Worker(URL.createObjectURL(blob));
}
